<template>
  <v-btn flat class="hvh-btn hvh-btn--primary m-1" @click="exportToExcel" v-if="data && data.length > 0">Export to Excel</v-btn>
</template>
<script>
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
     props: ['data', 'columns', 'fileName'],
  
  methods: {
    exportToExcel() {
      if (!this.data || this.data.length === 0) {
        console.error('No data to export.');
        return;
      }
     
      var wb = new ExcelJS.Workbook();
      var ws = wb.addWorksheet('Sheet1');
      var headers = this.columns.map(col => col.label);
      ws.addRow(headers);
      this.data.forEach(item => {
        var rowData = [];
        this.columns.forEach(col => {
          rowData.push(item[col.field]);
        });
        ws.addRow(rowData);
      });
      wb.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer]), this.fileName);
      });
    }
  }
}
</script>